module.exports = __webpack_public_path__ + "static/img/7.66f3f13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/7.png
// module id = DVjY
// module chunks = 0